export default __webpack_public_path__ + "static/media/SAS Alert Tone 10.44e70048.wav";